import { type MetaFunction } from "@remix-run/react"
import { Fragment } from "react"
import HeroSplit from "#app/components/hero-split"
import NavigationMarketing from "#app/components/navigation-marketing"

export const meta: MetaFunction = () => {
	return [
		{
			title: "Organizing a Family Calendar | Present Parent AI",
			description:
				"Organize your family's schedule with our intuitive Family Calendar feature. Coordinate events, track important dates, and manage everyone's activities in one centralized place. Our user-friendly calendar ensures that you stay connected and on top of your family's dynamic life, making planning together simple and stress-free.",
		},
	]
}

export default function FamilyCalendarFeature() {
	return (
		<Fragment>
			<NavigationMarketing />
			<HeroSplit
				tag="We're seeking parents for our affiliate program!"
				tagHref="/affiliates"
				ctaText="Start for free"
				ctaHref="/signup"
				imagePath="/img/family-activities-1.png"
				title="Organize Your Family Life with Ease"
				text="Streamline your family's schedule with our intuitive Family Calendar feature. Coordinate events, track important dates, and manage everyone's activities in one centralized place. Our user-friendly calendar ensures that you stay connected and on top of your family's dynamic life, making planning together simple and stress-free."
			/>
		</Fragment>
	)
}
